module.exports = __webpack_public_path__ + "static/gricd-1eba02daf5c3e0d20b361ac267dcdba7.png";